import { Card, Button, Modal, Form, Input, Avatar } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteArticle,
  getMyArticles,
  create_article
} from '../../../reducers/articlesReducer'

import { DeleteFilled } from '@ant-design/icons'
import Styles from '../index.module.css'

const { TextArea } = Input
const { Meta } = Card

const MyArticle = () => {
  let dispatch = useDispatch()
  const [modalVisible, setModalVisible] = useState(false)
  const [load, loading] = useState(2)
  const [form] = Form.useForm()

  const handleCancel = () => {
    setModalVisible(false)
    form.resetFields()
  }

  const onFinish = (values) => {
    let Article = {
      text: values.articleBody,
      title: values.articleTitle,
      url: values.url
    }
    dispatch(create_article(Article)).then(() => {
      dispatch(getMyArticles(user.username))
    })
    setModalVisible(false)
    form.resetFields()
  }

  function handleClick() {
    setModalVisible(true)
  }

  const user = useSelector((state) => state.auth.user)

  useEffect(() => {
    dispatch(getMyArticles(user.username))
  }, [dispatch])

  const result = useSelector((state) => state.articles)
  const articleData = result?.articles
  const navigate = useNavigate()

  return (
    <>
      <div className={Styles['articles-wrapper']}>
        <div className={Styles['article-title-container']}>
          <h2>Your Articles</h2>
          <div className={Styles['article-title-container']}>
            <Button
              shape="round"
              type="secondary"
              onClick={() => {
                navigate(`/app/articles`)
              }}
            >
              All Articles
            </Button>
            <Button
              type="secondary"
              shape="round"
              onClick={() => {
                navigate(`/app/myBookMarks`)
              }}
            >
              My Bookmarks
            </Button>
            <Button shape="round" type="primary" onClick={handleClick}>
              New Article
            </Button>

            <Modal
              title="Add New Article"
              visible={modalVisible}
              onOk={form.submit}
              onCancel={handleCancel}
              footer={[
                <Button key="cancel" onClick={handleCancel}>
                  Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={form.submit}>
                  Submit
                </Button>
              ]}
            >
              <Form
                form={form}
                name="normal_login"
                className="login-form"
                onFinish={onFinish}
              >
                <Form.Item
                  name="articleTitle"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your Article Title!'
                    }
                  ]}
                >
                  <Input type="text" placeholder="ArticleTitle" />
                </Form.Item>
                <Form.Item
                  name="articleBody"
                  rules={[
                    {
                      required: true,
                      message: 'Please input your article body!'
                    }
                  ]}
                >
                  <TextArea
                    type="text"
                    placeholder="article body"
                    autoSize={{ minRows: 5, maxRows: 6 }}
                  />
                </Form.Item>
                <Form.Item name="url">
                  <Input type="text" placeholder="article url" />
                </Form.Item>
              </Form>
            </Modal>
          </div>
        </div>

        {articleData.length == 0 ? (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh'
            }}
          >
            <h3
              style={{
                textAlign: 'center',
                marginTop: '20px',
                fontWeight: 500
              }}
            >
              No Articles Found
            </h3>
          </div>
        ) : (
          articleData?.map((article, index) => (
            <MyArticleCard key={index} article={article} />
          ))
        )}
      </div>
    </>
  )
}

const MyArticleCard = ({ article }) => {
  const navigate = useNavigate()
  let dispatch = useDispatch()

  const clickDelete = () => {
    return dispatch(deleteArticle(article.id))
  }

  const viewArticle = () => {
    navigate(`/app/articles/${article.id}`)
  }
  const user = useSelector((state) => state.auth.user)

  return (
    <div className={Styles['article-card-container']}>
      <Card hoverable className="article-card" onClick={viewArticle}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Meta
            style={{ alignItems: 'center' }}
            avatar={<Avatar src={article?.authorPersonId?.photo} />}
            title={
              <div style={{ fontWeight: 600, fontSize: '16px' }}>
                {article?.authorPersonId?.name || user.name}
              </div>
            }
          />
          {user?._id ===
            (article?.authorPersonId?._id || article?.authorPersonId) && (
            <Button
              type="icon"
              className={Styles['iconButton']}
              onClick={clickDelete}
            >
              <DeleteFilled />
            </Button>
          )}
        </div>
        <div style={{ fontSize: '16px', marginTop: '10px' }}>
          <b>{article?.title}</b>
        </div>
        <p>{article?.text}</p>
      </Card>
    </div>
  )
}

export default MyArticle
